import { ICryptoBundle } from './../../models/Crypto';
import { CryptoService } from './../../abstraction/crypto.service';
import { Component, OnInit, HostListener } from '@angular/core';
import { AuthService } from '../../abstraction/auth.service';

@Component({
  selector: 'app-crypto-bundle',
  templateUrl: './crypto-bundle.component.html',
  styleUrls: ['./crypto-bundle.component.scss'],
})
export class CryptoBundleComponent implements OnInit {
  bundles: ICryptoBundle[] = [];
  detailCardOpened = false;
  selectedBundle: ICryptoBundle;
  currency = 'ARS';
  variations = {};

  constructor(public cryptoService: CryptoService, public authService: AuthService) {}

  @HostListener('window:keydown', ['$event'])
  clickout(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.onCloseCryptoCard();
    }
  }

  ngOnInit(): void {
    this.authService.sendTikTokPageView(window.location.href).subscribe();
    this.cryptoService.bundlesVariations.subscribe((res) => {
      this.variations = res?.variations?.weekly || 0;
    });
    this.cryptoService.cryptoBundles.subscribe((bundles) => {
      this.bundles = bundles.sort((a, b) => {
        if (a.ticker === 'BNDL-CONS') return -1;
        if (a.ticker === 'BNDL-RCHAIN' && b.ticker === 'BNDL-RMETA') return -1;
      });
    });
  }

  selectBundle(selectedBundle: ICryptoBundle) {
    this.selectedBundle = selectedBundle;
    this.detailCardOpened = true;
  }

  onCloseCryptoCard() {
    this.detailCardOpened = false;
  }
}
